export class MemoryCache {
    constructor() {
        this.cache = {};
    }
    set(key, value) {
        this.cache[key] = value;
    }
    get(key) {
        return this.cache[key];
    }
    destroy() {
        this.cache = {};
    }
    clear(key) {
        delete this.cache[key];
    }
    async wrapPromise(key, fn) {
        const cached = this.get(key);
        if (cached) {
            return cached;
        }
        const response = await fn().then((res) => res);
        this.set(key, response);
        return response;
    }
}
